import { Component, Inject, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ProductStorage } from 'app/models/productStorage.model';
import { utcToLocalFormat } from 'app/shared/pipes/utc-to-local.pipe';
import { APIService } from 'app/services/api.service';
import { TranslateService } from '@ngx-translate/core';
import { ObjectStorage } from 'app/models/objectStorage.model';
import { IBaseResponse } from 'app/models/baseResponse.model';
import { AppHelper } from 'app/helpers/appHelper';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MenuStorage } from 'app/models/menuStorage.model';

@Component({
  selector: 'app-product-storages-modal',
  templateUrl: './product-storages-modal.component.html',
  styleUrls: ['./product-storages-modal.component.scss']
})
export class ProductStoragesModalComponent implements OnInit {
  productStorages: ProductStorage[] = [];
  dataSource = new MatTableDataSource(this.productStorages);
  columnsToDisplay = ['uploadRequestId', 'comment', 'createdAt', 'uploadedAt', 'published', 'uploadMessage', 'uploadResult', 'type', 'objectStorages'];
  dateFormat: string = utcToLocalFormat;
  constructor(
    private api: APIService,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: ProductStoragesModalComponentData,
  ) { }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.dataSource = new MatTableDataSource(this.data.menuStorage.productStorages);
  }

  getColumnHeader(columnHeaderValue: string): string {
    switch (columnHeaderValue) {
      case 'uploadRequestId':
        return this.translate.instant('PRODUCT_STORAGE.UPLOAD_REQUEST_ID');
      case 'createdAt':
        return this.translate.instant('PRODUCT_STORAGE.CREATED_AT');
      case 'uploadedAt':
        return this.translate.instant('MENU_HISTORY.UPLOADED_AT');
      case 'published':
        return this.translate.instant('MENU_HISTORY.PUBLISHED_AT');
      case 'uploadMessage':
        return this.translate.instant('MENU_HISTORY.UPLOAD_MESSAGE');
      case 'uploadResult':
        return this.translate.instant('MENU_HISTORY.UPLOAD_RESULT');
      case 'type':
        return this.translate.instant('PRODUCT_STORAGE.TYPE');
      case 'comment':
        return this.translate.instant('PRODUCT_STORAGE.COMMENT');
      default:
        return '';
    }
  }

  confirmPublish(productStorageId: string) {
   console.log('confirmPublish', productStorageId);
  }

  cancelPublish(productStorageId: string) {
    console.log('cancelPublish', productStorageId);
  }

  downloadObjectStorage(objectStorage: ObjectStorage, uploadedAt:string): void {
    const name = `${objectStorage.name}_${uploadedAt}`;
    this.api.getBucketById(objectStorage.id, name)
      .subscribe({
        next: (res: IBaseResponse<string>) => {
          if (res) {
            AppHelper.openList(res.data);
          }
        },
        error: (e) => {
          console.log(e);
          alert('Can\'t download file');
        }
      });
  }
}

export interface ProductStoragesModalComponentData{
  menuStorage: MenuStorage;
}
